import img1 from "../Assets/Image/CarouselContent/1ah.jpg";
import img2 from "../Assets/Image/CarouselContent/2ah.jpg";
import img3 from "../Assets/Image/CarouselContent/3ah.jpg";
export const CarouselData = [
  {
    image: img1,
    id: 1,
  },
  {
    image: img2,
    id: 2,
  },
  {
    image: img3,
    id: 3,
  },
];
